import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/space-view',
  routes: [
    {
      path: '/viewFile',
      component: resolve => require(['../views/viewFile.vue'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js